<template>
  <div>
    <!-- <Tabs
      value="declare"
      type="card"
      style="min-height:500px;min-width:1100px;"
    > -->
      <!-- 状态筛选 -->
      <!-- <span
        style="margin: 0 60px;"
        slot="extra"
      > -->
      <span style="float:right;">
        <RadioGroup
          v-model="flowStatus"
          type="button"
          @on-change="statusChange"
          v-show="kind !== 'todo'"
        >
          <Radio :label="1" v-show="kind !== 'scan'">待办</Radio>
          <Radio :label="2">进行中</Radio>
          <Radio :label="3">完成</Radio>
          <Radio :label="4">经办(进行)</Radio>
          <Radio :label="5">经办(完成)</Radio>
        </RadioGroup>
      </span>
      <Button
        type="success"
        size="small"
        slot="extra"
        @click="$emit('return',false)"
        style="margin-right:16px;"
        v-show="!kind"
      >返回上一页</Button>
      <!-- <TabPane
        label="退保审批"
        name="declare"
      > -->
        <div class="search-wrapper">
          <span>流程号：</span>
          <Input
            style="width:200px;margin-right:20px;"
            type="text"
            v-model="searchValue.WorkflowNum"
          ></Input>
          <span>标题：</span>
          <Input
            style="width:200px;margin-right:20px;"
            type="text"
            v-model="searchValue.WorkflowTitle"
          ></Input>
          <span>创建人：</span>
          <Input
            style="width:150px;margin-right:20px;"
            type="text"
            v-model="searchValue.CreatorRealName"
          ></Input>
          <Button
            type="primary"
            @click="search"
            style="margin:5px 10px;"
          >查询</Button>
          <span style="color:#ed4014">若退保信息有误，可退回提单人删除再次发起。</span>
        </div>
        <Table
          :columns="columns"
          :data="formData"
          style="min-width:1100px"
        ></Table>
        <Page
          :total="pageTotal"
          :current="currentPage"
          show-elevator
          show-total
          style="margin-top:5px;"
          @on-change="pageChange"
        ></Page>
      <!-- </TabPane> -->
    <!-- </Tabs> -->
    <!-- 流程审批选择 -->
    <flowBranch
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="visibleChange"
      @branchChoose="branchChoose"
      :branchType="branchType"
      ref="flowBranch"
    ></flowBranch>
    <!-- 流程人员选择 -->
    <Modal
      v-model="peopleSelectVisible"
      class="flow-modal"
      width="700px"
      title="流程人员选择"
    >
      <flowNext
        :child-msg="flowPeople"
        @toparentevent="handlePeopleSelect"
      ></flowNext>
      <div slot="footer">
        <Button @click="peopleSelectVisible=false">取消</Button>
        <Button
          @click="nextFlow"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
    <!-- 流程详情 -->
    <Modal v-model="flowHistoryVisible" title="流程详情" width="800">
      <flowHistory :flowDetailHistory="flowDetailHistory"></flowHistory>
      <div slot="footer"></div>
    </Modal>
    <!-- 退保信息 -->
    <Modal v-model="depositDetailVisible" title="退保信息" width="1000" :mask-closable="false">
      <depositRefundDetail :workFlowId="workFlowId" ref="refundData"></depositRefundDetail>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { getToDoList, getMyWorkItem, approvalFlow, getActivityUsers, deliverFlow, getFlowHistory, rejectFlow, getRejectActivityUsers, endFlow, getGetDoneList, deleteWorkFlow } from '@/lib/flow'
import FlowBranch from '@/components/flow/flowBranch'
import FlowNext from '@/components/flow/flowNext'
import FlowHistory from '@/components/flow/flowHistory'
import DepositRefundDetail from './depositRefundDetail'
import { formatDate } from '@/lib/tool'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import x2js from 'x2js'

const flowType = 'RM'

export default {
  name: 'depositApplyFlow',
  props: {
		kind: String
	},
  components: {
    FlowBranch,
    FlowNext,
    FlowHistory,
    DepositRefundDetail
  },
  data() {
    return {
      flowStatus: 1,
      searchValue: {
        WorkflowTitle: '',
        CreatorRealName: '',
        WorkflowNum: ''
      },
      columns: [
        {
          title: '流程单号',
          width: 140,
          key: 'SheetId'
        },
        {
          title: '标题',
          key: 'WorkflowTitle',
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'CreatedTime',
          align: 'center',
          width: 108,
          render: (h, params) => {
            const time = this.filterTime(params.row.CreatedTime)
            return h('div', time)
          }
        },
        {
          title: '结束时间',
          key: 'FinishedTime',
          align: 'center',
          width: 108,
          render: (h, params) => {
            const time = this.filterTime(params.row.FinishedTime)
            return h('div', time)
          }
        },
        {
          title: '创建人',
          width: 90,
          key: 'CreatorRealName',
          align: 'center'
        },
        // {
        //   title: '分子公司',
        //   width: 190,
        //   key: 'CreatedTime',
        //   align: 'center',
        //   render: (h, params) => {
        //     // return h('span', this.$options.filters.filterTime(params.row.CreatedTime))
        //     const flowInfo = JSON.parse(params.row.BusinessKey)
        //     let companyName = '未选择'
        //     if (flowInfo && flowInfo.company) {
        //       companyName = flowInfo.company
        //     }
        //     return h('span', companyName)
        //   }
        // },
        {
          title: '流程状态',
          width: 90,
          key: 'WorkflowInstanceState',
          align: 'center',
          render: (h, params) => {
            switch (params.row.WorkflowInstanceState) {
              case 3:
                return h('div', '成功')
                break
              case 5:
                return h('div', '驳回')
                break
              case 2:
                return h('div', '待办')
                break
            }
          }
        },
        {
          title: '操作',
          key: "Actions",
          align: 'center',
          width: 400,
          render: (h, params) => {
            let disabled = true
            let deleteDisabled = true
            if (this.flowStatus === 1) {
              disabled = false
            }
            if (this.flowStatus === 1 && params.row.ActivityName === '提单') {
              deleteDisabled = false
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.flowItemDetail = params.row
                    this.workFlowId = params.row.WorkflowInstanceId
                    this.depositDetailVisible = true
                  }
                }
              }, '退保信息'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: disabled
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.flowItemDetail = params.row
                    this.workFlowId = params.row.WorkflowInstanceId
                    this.isNormal = true
                    this.approvalFlowNext()
                  }
                }
              }, '流转'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: disabled
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.flowItemDetail = params.row
                    this.rejectFlow(params)
                  }
                }
              }, '退回'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: async () => {
                    this.flowItemDetail = params.row
                    // 获取流程详情
                    try {
                      let rep = await getFlowHistory(this.userPhone, this.flowItemDetail.WorkflowInstanceId)
                      this.flowDetailHistory = rep
                      this.flowHistoryVisible = true
                    } catch (err) {
                      console.error(err)
                      this.flowDetailHistory = []
                    }
                  }
                }
              }, '流程记录'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: deleteDisabled
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.workFlowId = params.row.WorkflowInstanceId
                    this.$Modal.confirm({
                      title: '流程删除',
                      content: '确认删除此保证金流程？删除后无法恢复',
                      onOk: async () => {
                        await deleteWorkFlow(params.row.WorkflowInstanceId)
                        this.search()
                        // 修改原订单状态
                        const depositRefundData = this.$refs.refundData.depositRefundData
                        let reviseOrderList = []
                        depositRefundData.forEach(deposit => {
                          reviseOrderList.push({
                            id: deposit.ordersId,
                            orderStatus: '2',
                            flowStatus: '0'
                          })
                        })
                        ajax.post(requestUrls.order.BatchUpdateOrders, reviseOrderList)
                      }
                    })
                  }
                }
              }, '删除'),
              // h('Button', {
              //   props: {
              //     type: 'success',
              //     size: 'small',
              //     disabled: disabled
              //   },
              //   style: {
              //     marginRight: '5px',
              //   },
              //   on: {
              //     click: () => {
              //       this.flowItemDetail = params.row
              //       this.workFlowId = params.row.WorkflowInstanceId
              //       this.isNormal = false
              //       this.approvalFlowNext()
              //     }
              //   }
              // }, '临'),
            ]);
          }
        },
      ],
      formData: [],
      pageTotal: 0,
      currentPage: 1,
      flowItemDetail: '',
      branchType: 'next',
      branchVisible: false,
      flowBranch: [],
      peopleSelectVisible: false,
      selectedPeople: '',
      flowPeople: '',
      flowHistoryVisible: false,
      flowDetailHistory: [],
      depositDetailVisible: false,
      workFlowId: '',
      isNormal: true
    }
  },
  computed: {
    userPhone() {
      return this.$store.state.session.user.phoneNumber
    },
    user() {
      return this.$store.state.session.user
    }
  },
  created() {
    if (this.kind === 'scan') {
      this.flowStatus = 2
    }
    this.search()
  },
  methods: {
    async search(page = 1) {
      this.currentPage = 1
      let rep = {}
      switch (this.flowStatus) {
        // 待办
        case 1:
          rep = await getToDoList(this.userPhone, { page: page, size: 10, whereStr: `AppId='${flowType}' and WorkflowTitle like '%${this.searchValue.WorkflowTitle}%' and CreatorRealName like '%${this.searchValue.CreatorRealName}%' and SheetId like '%${this.searchValue.WorkflowNum}%'` })
          this.$emit('num', rep.total)
          this.$store.commit('depositCount', rep.total)
          break
        // 进行中
        case 2:
          rep = await getMyWorkItem(this.userPhone, { page: page, size: 10, whereStr: `AppId='${flowType}' and WorkflowTitle like '%${this.searchValue.WorkflowTitle}%' and CreatorRealName like '%${this.searchValue.CreatorRealName}%' and SheetId like '%${this.searchValue.WorkflowNum}%'`, isHistory: 0 })
          break
        // 完成
        case 3:
          rep = await getMyWorkItem(this.userPhone, { page: page, size: 10, whereStr: `AppId='${flowType}' and WorkflowTitle like '%${this.searchValue.WorkflowTitle}%' and CreatorRealName like '%${this.searchValue.CreatorRealName}%' and SheetId like '%${this.searchValue.WorkflowNum}%'`, isHistory: 1 })
          break
        case 4:
          rep = await getGetDoneList(this.userPhone, { page: page, size: 10, whereStr: `AppId='${flowType}' and WorkflowTitle like '%${this.searchValue.WorkflowTitle}%' and CreatorRealName like '%${this.searchValue.CreatorRealName}%' and SheetId like '%${this.searchValue.WorkflowNum}%'`, isHistory: 0 })
          break
        case 5:
          rep = await getGetDoneList(this.userPhone, { page: page, size: 10, whereStr: `AppId='${flowType}' and WorkflowTitle like '%${this.searchValue.WorkflowTitle}%' and CreatorRealName like '%${this.searchValue.CreatorRealName}%' and SheetId like '%${this.searchValue.WorkflowNum}%'`, isHistory: 1 })
          break
      }
      this.formData = rep.rows
      this.pageTotal = rep.total
    },
    async approvalFlowNext() {
      this.$Spin.show()
      // 获取流程人员
      try {
        let rep = await getActivityUsers({ appId: flowType, userPhone: this.userPhone, taskId: this.flowItemDetail.TaskId })
        this.$Spin.hide()
        this.branchType = 'next'
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('流程人员获取失败')
      }
    },
    branchChoose(val) {
      this.flowPeople = val
      if (this.branchType === 'next' || this.branchType === 'start') {
        this.peopleSelectVisible = true
      }
      if (this.branchType === 'reject') {
        if (this.$refs.flowBranch.opinion === '' || !this.$refs.flowBranch.opinion) {
          this.$Message.info('请填写退回原因')
          return
        }
        this.rejectFlowConfirm()
      }
      this.branchVisible = false
    },
    async rejectFlowConfirm() {
      this.$Spin.show()
      try {
        let rep = await rejectFlow(this.userPhone, { taskId: this.flowItemDetail.TaskId, activityCode: this.flowPeople.ActivityCode, opinion: this.$refs.flowBranch.opinion })
        
        this.$Message.success('退回操作成功')
        this.$Spin.hide()
        // 刷新表格
        this.search()
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回操作失败')
      }
    },
    async rejectFlow() {
      // 获取流程人员
      this.$Spin.show()
      try {
        let rep = await getRejectActivityUsers(this.phoneNumber, this.flowItemDetail.TaskId)
        this.$Spin.hide()
        if (rep.length > 0) {
          this.branchType = 'reject'
          this.flowBranch = rep
          this.branchVisible = true
        } else {
          this.$Message.info('发起人无法退回')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回流程获取失败')
      }
    },
    async nextFlow() {
      this.$Spin.show()
      this.branchType = 'next'
      let opinion = this.$refs.flowBranch.opinion
      if (this.flowPeople.NextActivityName !== '结束') {
        // 流程转交
        try {
          let rep = await deliverFlow(this.userPhone, { taskId: this.flowItemDetail.TaskId, nextActivityCode: this.flowPeople.NextActivityCode, userId: this.selectedPeople.userId, opinion: opinion })
          this.$Spin.hide()
          this.$Message.success('流程流转到下一步')
          this.search()
          this.peopleSelectVisible = false
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程转交失败')
        }
      } else {
        // 结束流程
        try {
          let rep = await endFlow(this.userPhone, { taskId: this.flowItemDetail.TaskId, nextActivityCode: this.flowPeople.NextActivityCode, opinion: opinion })
          if (!this.isNormal) {
            this.$Spin.hide()
            this.$Message.success('流程结束成功')
            this.peopleSelectVisible = false
            this.search()
            return
          }
          // 创建退保订单
          const depositRefundData = this.$refs.refundData.depositRefundData
          
          let refundList = []
          depositRefundData.forEach(refundItem => {
            const x2Json = new x2js()
            const xmlJSON = x2Json.xml2js(refundItem.content)
            refundList.push({
              amount: refundItem.orders.orderAmountTotal,
              refundOA: this.flowItemDetail.SheetId,
              orderMethod: refundItem.orders.payChannel,
              numberDay: '',
              OrderPayTime: formatDate(),
              comment: '',
              cause: '',
              accountName: refundItem.orders.abpOrdersExp.bankName,
              bankAccount: refundItem.orders.abpOrdersExp.bankAccount,
              marginDetailId: refundItem.orders.clMarginId,
              orderNo: xmlJSON.root.orderNo,
              orderConfirm: this.user.name,
              ordersExp: {
                bankName: refundItem.orders.abpOrdersExp.bankName,
                bankAccount: refundItem.orders.abpOrdersExp.bankAccount,
                projectId: refundItem.projectId,
                groupId: refundItem.orders.abpOrdersExp.groupId,
                groupName: refundItem.orders.abpOrdersExp.groupName
              }
            })
          })
          await ajax.post(requestUrls.order.CreateRefundList, refundList)

          this.$Spin.hide()
          this.$Message.success('流程结束成功')
          this.peopleSelectVisible = false
          this.search()
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程结束失败')
        }
      }
    },
    handlePeopleSelect(selectedPeople) {
      this.selectedPeople = selectedPeople
    },
    visibleChange(val) {
      this.branchVisible = val
    },
    pageChange(page) {
      this.search(page)
    },
    statusChange(flowStatus) {
      this.flowStatus = flowStatus
      this.search()
    },
    filterTime(val) {
      if (!val) {
        return ''
      }
      let time = parseInt(val.slice(6, 19))
      time = formatDate(time).split(' ')[0]
      return time
    }
  },
  watch: {
    kind(val) {
      if (this.kind === 'scan') {
        this.flowStatus = 2
      }
      if (this.kind === 'todo') {
        this.flowStatus = 1
      }
      this.search()
		}
  }
}
</script>
